export default {
    title: '대기실',

    menu: {
        starDraw: '별 뽑기',
        seedLetter: '씨앗글자',
        recentResult: {
            label: '최근 수업 결과',
            short: '최근<br/>수업 결과',
        },
    },

    studentInfo: {
        gradeFormat: '{grade}학년',
        logoutConfirm: {
            title: '로그아웃',
            message: '로그아웃 할까요?',
        },
    },

    navigation: {
        toAvatars: '별 뽑기로 이동',
        toSeedLetter: '씨앗글자로 이동',
        toRecentResult: '최근 수업 결과로 이동',
    },

    languageSetting: {
        menuLabel: '언어 설정',
        title: '언어 설정',
        description: '학습 화면에서 도와주는 언어를 선택할 수 있어요.',
    },
};
